import { jwtDecode } from "jwt-decode";
import { UserType } from "../../model/userType";

export function isProvider() {
    const token = sessionStorage.getItem('token');
    if (token === null) return false;

    const decodedToken: any = jwtDecode(token);
    return decodedToken['type'] === UserType.Provider;
}

export function isAdmin() {
    const token = sessionStorage.getItem('token');
    if (token === null) return false;

    const decodedToken: any = jwtDecode(token);
    return decodedToken['type'] === UserType.BPSAdmin;
}

export function isCustomer() {
    const token = sessionStorage.getItem('token');
    if (token === null) return false;

    const decodedToken: any = jwtDecode(token);
    return decodedToken['type'] === UserType.Customer;
}

export function getUserType() : UserType | null {
    const token = sessionStorage.getItem('token');
    if (token === null) return null;

    const decodedToken: any = jwtDecode(token);
    return decodedToken['type'];
}

export function isGuest() : boolean {
    const token = sessionStorage.getItem('token');
    
    return token === null;
}